import { render, staticRenderFns } from "./VehicleInfo.vue?vue&type=template&id=030f70e1&scoped=true&"
import script from "./VehicleInfo.vue?vue&type=script&lang=js&"
export * from "./VehicleInfo.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInfo.vue?vue&type=style&index=0&id=030f70e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030f70e1",
  null
  
)

export default component.exports